import type { TrocarSenhaForm } from "../lib/useTrocarSenha.ts";

/** Campos do formulário "trocar senha", reusados no Sheet (mobile) e Modal (desktop). */
export function TrocarSenhaCampos({ f }: { f: TrocarSenhaForm }) {
  return (
    <>
      <div className="m-field">
        <label htmlFor="ts-atual">Senha atual</label>
        <input
          id="ts-atual"
          type="password"
          className="m-input"
          autoComplete="current-password"
          value={f.senhaAtual}
          onChange={(e) => f.setSenhaAtual(e.target.value)}
        />
      </div>
      <div className="m-field">
        <label htmlFor="ts-nova">Nova senha</label>
        <input
          id="ts-nova"
          type="password"
          className="m-input"
          autoComplete="new-password"
          value={f.nova}
          onChange={(e) => f.setNova(e.target.value)}
        />
      </div>
      <div className="m-field">
        <label htmlFor="ts-conf">Confirmar nova senha</label>
        <input
          id="ts-conf"
          type="password"
          className="m-input"
          autoComplete="new-password"
          value={f.confirma}
          onChange={(e) => f.setConfirma(e.target.value)}
        />
      </div>
      {f.erro && (
        <p className="m-alert danger" style={{ marginTop: 4 }}>
          {f.erro}
        </p>
      )}
      {f.sucesso && (
        <p
          className="m-alert"
          style={{ marginTop: 4, background: "var(--mat-3-soft)", color: "var(--mat-4)" }}
        >
          Senha alterada com sucesso.
        </p>
      )}
      <p className="spec" style={{ marginTop: 8 }}>
        A nova senha deve ter ao menos 8 caracteres.
      </p>
    </>
  );
}
